<template>
  <div id="aso">
    <div class="banner">
      <div class="banner_cont">
        <div class="left">
          <h1>ASO定制化营销服务</h1>
          <p>做行业真实看得见的优化，让好效果持续发声，</p>
          <p>更多定制化营销服务，详情登录</p>
          <!-- <img src="./ASO_banner1.png" alt=""> -->
        </div>
        <img src="https://static.adjuz.net/asmmaster/img/website_2.png" alt="" class="right_bgk">
        <div class="right" v-if="islogin && !ispass">
          <h1>ASO登录</h1>
          <section>
            <!-- <i class="iconfont iconshouji"></i> -->
            <img src="./svg1.svg" alt="" class="svg">
            <input type="text" v-model="user" placeholder="请输入您的工作邮箱">
          </section>
          <section>
            <!-- <i class="iconfont iconhuaban-a"></i> -->
            <img src="./svg2.svg" alt="" class="svg">
            <input type="password" v-model="pass" placeholder="密码（字母、数字、至少6位）" @keyup.enter="btnsubmit">
          </section>
          <p class="checkbox_input">
            <span class="ca" @click="isremember = !isremember">
              <input type="checkbox" name="" id="" v-model="isremember">
              近7天内记住我
            </span>
            <span style="text-align:right;display: block;" @click="islogin = false">忘记密码？</span>
          </p>
          <div @click="btnsubmit">登录</div>
        </div>
        <div class="right" v-if="!islogin && !ispass">
          <h1>忘记密码</h1>
          <section>
            <!-- <i class="iconfont iconshouji"></i> -->
            <img src="./svg1.svg" alt="" class="svg">
            <input type="text" v-model="user2" placeholder="请输入您的工作邮箱">
          </section>
          <section class="codeinput">
            <!-- <i class="iconfont iconhuaban-a"></i> -->
            <img src="./svg2.svg" alt="" class="svg">
            <input type="text" v-model="code" placeholder="验证码" @keyup.enter="btnsubmit2">
            <img :src="codeurl" alt="">
            <span @click="loadcode">看不清，换一张</span>
          </section>
          <div @click="btnsubmit2" style="margin-top:10px;">发送到验证邮箱</div>
          <p class="oldpass">
            想起来了<span @click="logoin">&nbsp;立即登录</span>
          </p>
        </div>
        <div class="right" v-if="ispass ">
          <h1>忘记密码</h1>
          <h2>
            请前往<b>{{user2}}</b>查阅来自巨掌移动广告
            平台的邮件，从邮件的提示中重设您的密码。
          </h2>
          <div @click="callbacklogin" style="margin-top:10px;">返回上一步</div>
          <p class="oldpass">
            想起来了<span @click="logoin">&nbsp;立即登录</span>
          </p>
        </div>
      </div>
    </div>
    <div class="top_2">
      <div class="h1_title">
        <h1>业务生态</h1>
        <p>专注移动营销数据赋能，探索效果领域无限可能</p>
      </div>
      <div class="search">
        <div class="search_cont">
          <div class="swiper-container">
            <div class="swiper-wrapper">
              <div class="swiper-slide">
                <div class="search_box">
                  <div class="left">
                    <h1>
                      ASO关键词
                      </br>
                      搜索效果优化
                    </h1>
                    <p>
                      提升品牌在APP Store关键词搜索结果
                      </br>
                      的排名增加品牌曝光度
                    </p>
                  </div>
                  <img src="https://static.adjuz.net/asmmaster/img/website_3.png" alt="">
                </div>
              </div>
              <div class="swiper-slide">
                <div class="search_box">
                  <div class="left">
                    <h1>
                      IOS榜单效果优化
                    </h1>
                    <p>
                      提升品牌免费、付费、总榜、分类、
                      </br>
                      榜单排名，获得大量自然下载量
                    </p>
                  </div>
                  <img src="https://static.adjuz.net/asmmaster/img/website_4.png" alt="">
                </div>
              </div>
            </div>
            <div class="swiper-pagination"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="h1_title">
      <h1>ASO合作客户</h1>
      <p>累计服务超过2000家企业和应用开发者，拥有一批互信共赢的头部企业</p>
    </div>
    <div class="home_fr">
      <section>
        <div v-for="(ele,index) in frlist" :key="index" :class="{nomargin: index % 4 == 0}" v-show="index <12 || (index >= 12 && tofriend)">
          <img :src="ele" alt="">
        </div>
      </section>
      <div class="home_fr_mo" @click="tofriend = !tofriend">
        {{!tofriend ?  '查看更多' : '收起'}}
        <!-- <i class="iconfont iconxia" v-if="!tofriend"></i>
        <i class="iconfont iconshang" v-if="tofriend"></i> -->
      </div>
    </div>
    <footerbom></footerbom>
  </div>
</template>

<script type="text/javascript">
import qs from "qs";
export default {
  data() {
    return {
      isremember: false,
      user: "",
      pass: "",
      frlist: [
        require("./ASO_fr1.png"),
        require("./ASO_fr2.png"),
        require("./ASO_fr3.png"),
        require("./ASO_fr4.png"),
        require("./ASO_fr5.png"),
        require("./ASO_fr6.png"),
        require("./ASO_fr7.png"),
        require("./ASO_fr8.png"),
        require("./ASO_fr9.png"),
        require("./ASO_fr10.png"),
        require("./ASO_fr11.png"),
        require("./ASO_fr12.png"),
        require("./ASO_fr13.png"),
        require("./ASO_fr14.png"),
        require("./ASO_fr15.png"),
        require("./ASO_fr16.png"),
        require("./ASO_fr17.png"),
        require("./ASO_fr18.png"),
        require("./ASO_fr19.png"),
        require("./ASO_fr20.png"),
        require("./ASO_fr21.png"),
        require("./ASO_fr22.png"),
        require("./ASO_fr23.png"),
        require("./ASO_fr24.png"),
      ],
      tofriend: false,
      islogin: true,
      ispass: false,
      user2: "",
      code: "",
      codeurl:
        "https://account.aso.adjz.com/Code.aspx?" + new Date().getTime(),
    };
  },
  computed: {},
  components: {},
  created() { },
  destroyed() { },
  mounted() {
    var swiper = new Swiper(".swiper-container", {
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      slidesPerView: 4,
      paginationClickable: true,
      loop: true,
      slidesPerView: "auto",
      speed: 1000,
      autoplay: {
        disableOnInteraction: false,
        delay: 4000,
      },
    });
    if (this.$ls.get("asoadmin")) {
      this.user = this.$ls.get("asoadmin").user;
      this.pass = this.$ls.get("asoadmin").pass;
    }
  },
  methods: {
    btnsubmit() {
      if (!this.user) {
        this.$warningBox("请输入邮箱");
        return;
      }
      if (!this.pass) {
        this.$warningBox("请输入密码");
        return;
      }
      // let passTest = /^[a-zA-Z0-9]{6,16}$/g;
      // if (!passTest.test(this.pass)) {
      //   this.$warningBox("密码格式不正确");
      //   return;
      // }
      var formdata = new FormData();
      formdata.append("data[User][email]", this.user);
      formdata.append("data[User][password]", this.pass);
      formdata.append("isapi", true);

      this.$https.post(this.$axiosurl + "/login", formdata).then((res) => {
        if (res.indexOf("错误") == -1) {
          this.$warningBox("账号或密码不正确");
        } else if (res.indexOf("登录成功") != -1) {
          this.$ls.set("asoadmin", {
            user: this.user,
            pass: this.pass,
          });
          window.location = "https://aso.adjz.com";
        } else {
          this.$warningBox("登录失败");
        }
      });
    },
    btnsubmit2() {
      if (!this.user2) {
        this.$warningBox("请输入邮箱");
        return;
      }
      if (!this.code) {
        this.$warningBox("请输入验证码");
        return;
      }
      var formdata = new FormData();
      formdata.append("__EVENTTARGET", "btnSave");
      formdata.append("__VIEWSTATEGENERATOR", "EB622C27");
      formdata.append("data[User][Name]", this.user2);
      formdata.append("data[User][Code]", this.code);
      this.$https.post(this.$axiosurl + "/getpwd", formdata).then((res) => {
        if (res.indexOf(this.user2) == -1) {
          this.$warningBox("邮箱或验证码不正确");
          this.codeurl =
            "https://account.aso.adjz.com/Code.aspx?" + new Date().getTime();
        } else {
          //this.$warningBox("从邮件的提示中重设您的密码");
          this.ispass = true;
          //this.islogin = true;
        }
      });
    },
    getcode() { },
    medpass() {
      this.islogin = false;
      this.getcode();
    },
    logoin() {
      this.ispass = false;
      this.islogin = true;
    },
    callbacklogin() {
      this.ispass = false;
      this.islogin = false;
    },
    loadcode() {
      this.codeurl =
        "https://account.aso.adjz.com/Code.aspx?" + new Date().getTime();
    },
  },
};
</script>

<style lang="less" scoped>
#aso {
  width: 100%;
  .banner {
    width: 100%;
    height: 500px;
    background: url("https://static.adjuz.net/asmmaster/img/website_1.jpg")
      no-repeat center center;
    background-size: cover;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: -1px;
    .banner_cont {
      width: 1200px;
      height: 406px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      user-select: none;
      position: relative;
      .left {
        h1 {
          font-size: 52px;
          font-family: Microsoft YaHei;
          font-weight: bold;
          color: #fefefe;
          letter-spacing: 4px;
          margin-bottom: 30px;
        }
        p {
          font-size: 24px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #fefefe;
          line-height: 60px;
          letter-spacing: 2px;
        }
        img {
          margin-top: 20px;
        }
      }
      .right_bgk {
        position: absolute;
        right: -120px;
        top: 0;
        width: 700px;
        z-index: 1;
        height: 406px;
      }
      .right {
        position: absolute;
        right: 0;
        top: 0;
        z-index: 2;
        width: 440px;
        height: 95%;
        background: #fff;
        border-radius: 12px;
        box-sizing: border-box;
        box-shadow: 0 0 12px rgba(0, 0, 0, 0.3);
        padding: 0 30px;
        display: flex;
        flex-direction: column;
        align-items: center;
        h1 {
          margin: 50px 0 30px;
          font-size: 24px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #1182ff;
        }
        h2 {
          font-size: 18px;
          color: #666;
          line-height: 40px;
          width: 100%;
          margin: 20px 0;
          b {
            font-size: 18px;
            margin: 0 3px;
            color: #ff6e01;
          }
        }
        span {
          display: block;
          text-align: left;
          color: #999;
          cursor: pointer;
          width: 80px;
          &:hover {
            color: #409eff;
          }
        }
        p {
          width: 100%;
          color: #999;
          &.oldpass {
            display: flex;
            justify-content: center;
            text-align: center;
            margin-top: 20px;
            span {
              color: #409eff;
            }
          }
          &.checkbox_input {
            display: flex;
            justify-content: space-between;
            align-items: center;
            input {
              width: 16px;
              height: 16px;
              position: relative;
              margin-right: 4px;
              cursor: pointer;
            }
            span {
              white-space: nowrap;
              width: 120px;
              display: flex;
              align-items: center;
            }
            .ca {
              &:hover {
                color: #999;
              }
            }
          }
        }
        section {
          width: 100%;
          height: 44px;
          border-bottom: 1px solid #d3dede;
          position: relative;
          margin-bottom: 20px;
          &.codeinput {
            input {
              width: 140px;
            }
            img {
              width: 100px;
              height: 36px;
              position: absolute;
              left: 170px;
              top: 0;
            }
            span {
              position: absolute;
              right: 20px;
              top: 10px;
              cursor: pointer;
              color: #409eff;
              display: block;
              white-space: nowrap;
            }
            .svg {
              position: absolute;
              left: 4px;
              z-index: 1;
              top: 46%;
              transform: translateY(-50%);
              width: 24px;
              height: 24px;
            }
          }
        }
        .svg {
          position: absolute;
          left: 4px;
          z-index: 1;
          top: 46%;
          transform: translateY(-50%);
          width: 24px;
          height: 24px;
        }
        i {
          position: absolute;
          left: 4px;
          color: #666;
          z-index: 1;
          top: 50%;
          font-size: 16px;
          transform: translateY(-50%);
        }
        input {
          width: 380px;
          position: absolute;
          height: 44px;
          left: 0;
          right: 0;
          border: none;
          //line-height: 44px;
          box-sizing: border-box;
          padding-left: 31px;
          &::-webkit-input-placeholder {
            color: #999;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
          }
        }
        div {
          width: 100%;
          height: 50px;
          background: #409eff;
          text-align: center;
          line-height: 50px;
          color: #fff;
          cursor: pointer;
          border-radius: 6px;
          margin-top: 30px;
          font-size: 16px;
          letter-spacing: 4px;
          &:hover {
            background: #0a92f5;
          }
        }
      }
    }
  }
  .search {
    width: 100%;
    height: 584px;
    // background: url("./ASO_search1.png") no-repeat center center;
    // background-size: cover;
    .search_cont {
      width: 100%;
      margin: 0px auto 0px;
      height: 550px;
      display: flex;
      img {
        //margin-top: 130px;
        width: 480px;
        height: 500px;
      }
    }
  }
  .top_2 {
    background-image: url("https://static.adjuz.net/asmmaster/img/website_5.png");
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    overflow: hidden;
  }
  .h1_title {
    width: 100%;
    text-align: center;
    margin: 60px 0 50px;
    h1 {
      font-size: 36px;
      text-align: center;
      position: relative;
      margin: 60px 0 40px;
      letter-spacing: 4px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #333333;
      &::after {
        position: absolute;
        content: "";
        width: 70px;
        height: 4px;
        background: #409eff;
        bottom: -16px;
        left: 50%;
        transform: translateX(-50%);
      }
    }
    p {
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #666666;
    }
  }
  //合作伙伴
  .home_fr {
    width: 100%;
    section {
      width: 1200px;
      display: flex;
      flex-wrap: wrap;
      margin: 0 auto;
      div {
        width: 20%;
        height: 96px;
        margin-bottom: 30px;
        margin-left: 6.66%;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: all 0.3s;
        border-radius: 10px;
        overflow: hidden;
        &.nomargin {
          margin-left: 0;
        }
        &:hover {
          box-shadow: 0 8px 8px 0 #e0e6e7;
          transform: translateY(-6px);
        }
      }
    }
    .home_fr_mo {
      text-align: center;
      margin: 24px 0 56px;
      font-size: 18px;
      letter-spacing: 2px;
      cursor: pointer;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #666666;
      line-height: 24px;
    }
  }
}
</style>
<style lang="less">
#aso {
  .swiper-container {
    height: 560px;
  }
  .swiper-pagination {
    .swiper-pagination-bullet {
      width: 37px;
      border-radius: 4px;
      height: 6px;
    }
  }
}
.search_box {
  width: 1200px;
  height: 508px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  padding: 0 80px 0px 40px;
  margin: 0 auto;
  .left {
    margin-top: -30px;
  }
  h1 {
    color: #333;
    position: relative;
    line-height: 60px;
    letter-spacing: 3px;
    font-size: 32px;
    font-family: Microsoft YaHei;
    font-weight: bold;
  }
  p {
    font-size: 24px;
    color: #666;
    margin-top: 20px;
    letter-spacing: 2px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    line-height: 40px;
  }
}
</style>



// WEBPACK FOOTER //
// src/page/aso/index.vue